<script setup lang="ts">

const { user, fetchUser } = usePanel()
const colorMode = useColorMode()
const { $pwa } = useNuxtApp()
const toast = useToast()

useHead({
  htmlAttrs: {
    dir: 'rtl'
  }
})

useAsyncData(`fetch-app-data`, async () => {
  await fetchUser();
}, {
  lazy: true
})

onMounted(() => {
  if (user.value && user.value.settings?.theme) {
    colorMode.preference = user.value.settings?.theme
  }

  window.addEventListener('beforeinstallprompt', (e) => {
    if ($pwa && !sessionStorage.getItem('pwa_prompt_shown')) {
      sessionStorage.setItem('pwa_prompt_shown', 'true')

      toast.add({
        id: 'pwa_install_prompt',
        title: 'تجربه بهتر با نصب اپلیکیشن',
        description: 'برای تجربه بهتر در استفاده از خنیاگر، وب اپلیکیشن را نصب کنید.',
        duration: 0,
        actions: [
          {
            label: 'نصب',
            variant: 'solid',
            color: 'success',
            onClick: () => {
              $pwa?.install()
              toast.remove('pwa_install_prompt')
            }
          },
          {
            label: 'بیخیال',
            onClick: () => {
              $pwa.cancelInstall()
              toast.remove('pwa_install_prompt')
            }
          }
        ]
      })
    }
  })
})
</script>

<template>
  <NuxtPwaManifest />
  
  <Popup />
  <NuxtLayout>
    <NuxtLoadingIndicator />

    <NuxtPage />
  </NuxtLayout>
</template>